import { Component, Vue } from "vue-property-decorator";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import * as firebase from "firebase/app";


@Component({
  components: { ConfirmDlg }
})
export default class AddToEvent extends Vue {

  public externalPersonEmail = ''
  public errorMessage = ''
  public state = 'Adding'

  mounted() {
    this.externalPersonEmail = this.$route.params.email
    if (this.$route.params.email && this.$route.params.eventId && this.$route.params.passcodeHash) {
      this.addExternalPersonToEvent(this.$route.params.email, this.$route.params.eventId, this.$route.params.passcodeHash)
    }
  }

  routeToCalendar(): void {
    this.$router.push("/calendar");
  }

  addExternalPersonToEvent(email, eventId, passcodeHash): void {
    try {
      //get event
      firebase.firestore().collection('calender')
        .doc(eventId)
        .get().then((querySnap: any) => {
          const codeHash = querySnap.data().externalHostedPasscodeHash;

          //check external person code
          if (codeHash === passcodeHash) {

            console.log('External person code hash verified')

            //add external person to event 
            firebase.firestore().collection('calender')
              .doc(eventId)
              .update({ "showForExternalPerson": true })
              .then(() => {
                console.log('External person added to an event')
                this.state = 'Added'
                setTimeout(() => this.routeToCalendar(), 2000)
              })
          }
          else {
            console.error('Error : External person code hash is not valid')
            this.errorMessage = 'Unable to add external person to the event. External person code hash is not valid.'
          }
        });
    } catch (error) {
      console.error('Error :', error);
      this.errorMessage = 'Unable to add external person to the event'
    }
  }

}
